const APPINFO = 'https://support.epson.net/appinfo/';
const APPNAME = {
    iprint: 'iprint',
    creative: 'creative',
    nenga: 'nenga',
    smartpanel: 'smartpanel',
    photoplus_jp: 'photoplus_jp',
    lineprint: 'lineprint'
};
const COMPATIVLE_PRINTERS_URL = {
    iprint: (APPINFO + APPNAME.iprint + '/'),
    // Ver3.1よりCreativePrintの対応プリンターリンク変更
    // creative: (APPINFO + APPNAME.creative + '/'),
    creative: "https://support.epson.net/rd/creativeprint/",
    nenga: (APPINFO + APPNAME.nenga + '/model/index.html'),
    smartpanel: "https://support.epson.net/rd/smartpanel/",
    photoplus_jp: "https://www.epson.jp/products/colorio/guide/software/",
    lineprint_jp: "https://www.epson.jp/connect/mcloud/mailprint/#anchor6",
    lineprint_zh: "https://www.epson.com.tw/%E8%A1%8C%E5%8B%95%E5%88%97%E5%8D%B0%E5%8F%8A%E6%8E%83%E6%8F%8F%E8%A7%A3%E6%B1%BA%E6%96%B9%E6%A1%88/%E9%80%8F%E9%81%8E-LINE-%E8%BC%95%E9%AC%86%E5%88%97%E5%8D%B0/p/LINEPRINT"
};

const CompativlePrinter = {
    printerlistURL: function (appname, lg2) {
        if(appname == APPNAME.lineprint) {
            if (lg2 == 'ja') {
                return COMPATIVLE_PRINTERS_URL.lineprint_jp
            }else if (lg2 == 'zh') {
                return COMPATIVLE_PRINTERS_URL.lineprint_zh
            }
        }else {
            const url = COMPATIVLE_PRINTERS_URL[appname];

            // if (appname === APPNAME.iprint 
            //     || appname === APPNAME.creative){
            if (appname === APPNAME.iprint ){
                switch (lg2) {
                    case 'c2':
                        return url + 'cn/'

                    case 'zh':
                        return url + 'tw/'

                    // アプリ非対応言語
                    case 'id':
                    case 'pl':
                    case 'th':
                    case 'tr':
                    case 'sv':
                    case 'ro':
                    case 'el':
                    case 'cs':
                    case 'nn':
                    case 'da':
                    case 'fi':
                    case 'hu':
                    case 'uk':
                    case 'ms':
                        return url + 'en/'

                    default:
                        return url + lg2 + '/'
                }
            }else {
                return url
            }
        }
    }
}
export default CompativlePrinter